import axios from '@/plugins/axios';
import { API_G_130_NOHINSAKI_MST_MENTE } from '@/constants/api';
import type { Module } from 'vuex';
import {
  nohinsakiMstDetail,
  nohinsakiMstType,
} from '@/types/G_kaigai/G_130_NohinsakiMstMente';
import { removeBlankOrNullOrZero } from '@/utils/utils';

export type G_130 = {
  nohinsakiList: nohinsakiMstType[];
  nohinsakiMst: nohinsakiMstType | nohinsakiMstDetail | Record<string, unknown>;
};

enum HTTP_REQUEST {
  GET = 'GET',
}

const g_130: Module<G_130, unknown> = {
  namespaced: true,
  state() {
    return {
      nohinsakiList: [],
      nohinsakiMst: {},
    };
  },
  mutations: {
    SET_NOHINSAKI_LIST(state, payload: nohinsakiMstType[]) {
      state.nohinsakiList = payload;
    },
    SET_NOHINSAKI_MST(state, payload: nohinsakiMstType) {
      state.nohinsakiMst = payload;
    },
    RESET_NOHINSAKI_LIST(state) {
      state.nohinsakiList = [];
    },
    RESET_NOHINSAKI_MST(state) {
      state.nohinsakiMst = {};
    },
  },
  getters: {
    nohinsakiList: (state) => state.nohinsakiList,
    nohinsakiMst: (state) => state.nohinsakiMst,
  },
  actions: {
    // 問合せ画面の data 取得
    async getNohinsakiList({ dispatch, commit }, params) {
      try {
        dispatch('common/setIsLoading', true, { root: true });
        const res = await axios({
          url: API_G_130_NOHINSAKI_MST_MENTE,
          params: removeBlankOrNullOrZero(params),
          method: HTTP_REQUEST.GET,
        });
        //const { responseData } = res.data;
        commit('SET_NOHINSAKI_LIST',
          res.data.responseData && res.data.responseData.length > 0
            ? res.data.responseData
            : []);
        return await Promise.resolve(res);
      } catch (err) {
        return await Promise.reject(err);
      } finally {
        dispatch('common/setIsLoading', false, { root: true });
      }
    },
    // ヘッダ入力画面の data 取得
    async getNohinsakiMst({ commit }, params) {
      try {
        const url = `${API_G_130_NOHINSAKI_MST_MENTE}/mst`;

        const res = await axios({
          url,
          params: removeBlankOrNullOrZero(params),
          method: HTTP_REQUEST.GET,
        });
        const { responseData } = res.data;
        commit('SET_NOHINSAKI_MST', responseData);
        return await Promise.resolve(res);
      } catch (err) {
        return await Promise.reject(err);
      }
    },
    //  問合せ画面の API 呼び出しで error が帰ってきた場合、一覧を clear する必要がある
    resetNohinsakiList({ commit }) {
      commit('RESET_NOHINSAKI_LIST');
    },
    // ヘッダ入力画面を ADD で起動する場合、store を reset する必要がある
    resetNohinsakiMst({ commit }) {
      commit('RESET_NOHINSAKI_MST');
    },

  },
};

export default g_130;
